// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"c66f2342","424":"57e205b6","455":"9edba523","484":"75628d74","551":"12ef7497","573":"aed72c8c","578":"31673e02","795":"0098cbbc"}[chunkId] + ".chunk.js";
};